<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      @if (currentRole == userRoles.Client) {
        <span class="title-small-bold text-primary-color">Driver Details for {{ config.data.driverName }}</span>
        <app-tag
          [content]="'#' + config.data.driverId"
          sizeClass="tag-sm"
          severityClass="secondary"></app-tag>
      } @else {
        <span class="title-small-bold text-primary-color">Contractor Live Profile of {{ config.data.driverName }}</span>
        <span class="text-light-color text-base font-normal">#{{ config.data.driverId }}</span>
      }
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (click)="ref.close()"
      (keydown.enter)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<app-tabs [initialTabIndex]="0">
  <app-tab tabTitle="Profile Details">
    <div class="flex gap-spacing-xl flex-column">
      @if (appSettings?.viewContractorBasicInfo) {
        <div class="info-section">
          <h6 class="text-base">Basic Information</h6>
          @if (currentRole == userRoles.Client) {
            <app-info-card
              [data]="
                {
                  gender: config.data.contractorData.basicInformation.gender,
                  primaryLanguage: config.data.contractorData.basicInformation.primaryLanguage
                } | infoCard
              ">
            </app-info-card>
          } @else {
            <app-info-card [data]="config.data.contractorData.basicInformation | infoCard"></app-info-card>
          }
        </div>
      }

      @if (appSettings?.viewDriverProviderContacts && currentRole != userRoles.Client) {
        <div class="table-section">
          <h6 class="text-base">Driver Provider Contacts</h6>
          <app-basic-table
            [showIndex]="true"
            [tableData]="config.data.contractorData.driverProviderContacts | basicTable"></app-basic-table>
        </div>
      }
    </div>
  </app-tab>

  @if (appSettings?.viewBankInformation && currentRole != userRoles.Client) {
    <app-tab tabTitle="Bank Information">
      <div class="flex gap-spacing-xl flex-column">
        <div class="info-section">
          <h6 class="text-base">Bank Information</h6>
          <app-info-card [data]="config.data.contractorData.bankInfo"></app-info-card>
        </div>
      </div>
    </app-tab>
  }

  @if (appSettings?.viewVehicleDetails) {
    <app-tab tabTitle="Vehicle details">
      <div class="flex gap-spacing-xl flex-column">
        <div class="info-section">
          <h6 class="text-base">Vehicle Details</h6>
          @if (config.data?.contractorData?.vehicleInfo != null) {
            <app-info-card [data]="config.data.contractorData.vehicleInfo"></app-info-card>
          } @else {
            <app-data-not-found field="Vehicle Details"></app-data-not-found>
          }
        </div>
      </div>
    </app-tab>
  }

  @if (appSettings?.viewContractorNotificatoins && currentRole != userRoles.Client) {
    <app-tab tabTitle="Notifications">
      <h6 class="text-base">Notifications</h6>
      <div class="notifications-section flex flex-column gap-spacing-xs">
        @for (date of objectKeys(notifications()); track $index) {
          <span class="day text-base text-caption-color">{{ date }}</span>
          @for (n of notifications()![date]; track $index) {
            <div class="notification bg-white py-spacing-xs px-spacing-xl border-1 border-neutral-base-primary-border border-round-lg">
              <div class="notification-header flex justify-content-between gap-spacing-xs">
                <div class="left flex gap-spacing-xl">
                  <h6 class="text-base">{{ n.Title }}</h6>
                  <span class="time text-sm text-lightest-color">{{ n.CreatedAtUtc | date: "shortTime" }}</span>
                </div>
                <div class="right hidden md:flex gap-spacing-default align-items-center">
                  <span class="text-sm text-lightest-color font-light">Sent by</span>
                  <span class="text-sm text-lightest-color font-medium">{{ n.CreatedByAccountFirstName }} {{ n.CreatedByAccountLastName }}</span>

                  @if (n.ReadAtUtc) {
                    <div class="flex gap spacing-default align-items-center">
                      <span class="text-sm text-lightest-color font-light">. Read at </span>
                      <span class="text-sm text-lightest-color font-medium">&nbsp;{{ n.ReadAtUtc | date: "mediumDate" }}</span>
                      <span class="text-sm text-lightest-color font-medium">&nbsp;{{ n.ReadAtUtc | date: "shortTime" }}</span>
                    </div>
                  }
                </div>
              </div>
              <div class="notification-content">
                <p class="mb-0 text-base text-caption-color">{{ n.Body }}</p>
              </div>

              <hr class="my-spacing-2xs border-neutral-base-primary-border block md:hidden" />

              <div class="right flex md:hidden flex-column">
                <div class="flex gap-spacing-default align-items-center">
                  <span class="text-sm text-lightest-color font-light">Sent by</span>
                  <span class="text-sm text-lightest-color font-medium">{{ n.CreatedByAccountFirstName }} {{ n.CreatedByAccountLastName }}</span>
                </div>

                @if (n.ReadAtUtc) {
                  <div class="flex gap-spacing-default align-items-center">
                    <span class="text-sm text-lightest-color font-light"> Read at </span>
                    <span class="text-sm text-lightest-color font-medium">&nbsp;{{ n.ReadAtUtc | date: "mediumDate" }}</span>
                    <span class="text-sm text-lightest-color font-medium">&nbsp;{{ n.ReadAtUtc | date: "shortTime" }}</span>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>

      <hr class="-mx-3 border-neutral-base-primary-color opacity-100 mb-0" />

      <div class="new-notification-section py-spacing-xl">
        <h6 class="text-base font-semibold">Send New Notification to Contractor</h6>
        <form #form="ngForm">
          <div class="flex flex-column gap-spacing-xs">
            <div class="form-group">
              <p-select
                #titleInp="ngModel"
                name="title"
                [(ngModel)]="notificationTitle"
                required
                [options]="dropdownOptions"
                optionValue="name"
                optionLabel="name"
                placeholder="Select Notification Title" />
              @if (titleInp.dirty && titleInp.errors && titleInp.errors["required"]) {
                <small class="input-helper-text label-medium-regular text-danger-color">This field is required.</small>
              }
            </div>
            <div class="form-group textarea-container relative">
              <textarea
                rows="5"
                cols="30"
                #bodyInp="ngModel"
                pTextarea
                [autoResize]="true"
                name="body"
                required
                [(ngModel)]="notificationBody"
                [value]="''"
                placeholder="Type notification here...">
              </textarea>
              <div class="btn-container">
                <app-button
                  (btnClick)="sendNotification(form)"
                  [disabled]="!!titleInp.invalid || !!bodyInp.invalid"
                  label="Send Notification"
                  sizeClass="p-button-sm"
                  severity="primary"></app-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </app-tab>
  }

  @if (appSettings?.viewContractorDeviceInfo && currentRole != userRoles.Client) {
    <app-tab tabTitle="Device Info">
      <div class="flex gap-spacing-xl flex-column">
        <div class="info-section">
          <h6 class="text-base">Basic Information</h6>
          <app-info-card [data]="config.data.contractorData.deviceBasicInfo"></app-info-card>
        </div>

        <div class="info-section">
          <h6 class="text-base">ADROIT App Information</h6>
          <app-info-card [data]="config.data.contractorData.adroitAppInfo"></app-info-card>
        </div>
      </div>
    </app-tab>
  }
</app-tabs>

<div class="p-dialog-footer pt-spacing-3xl px-0">
  <app-button
    label="Close"
    (click)="ref.close()"
    (keydown.enter)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
</div>
